import React from 'react'
import styles from './DataTable.module.scss'

interface DataTableProps {
  children: React.ReactNode
  className?: never
}

export const DataTable: React.FC<DataTableProps> = ({ children }) => (
  <table className={styles.table}>{children}</table>
)
